import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import * as PR from "../../../../prime-react/index";
import 'swiper/css';

import "./AlertNotifications.scss";
import { alertTypeIcons, alertTypes } from '../graph-and-stats/GraphConfig';
import { currencyFormat, DateFormat } from '../../../../utils/reuse';

const AlertNotifications = ({ alertListData, searchRequest, isLoading, modalHandler, groupId }) => {

  const navigate = useNavigate();
  const pageDisplayCount = 200;
  const alertDetectedData = useMemo(() => (Array.isArray(alertListData) ? alertListData : []), [alertListData]);
  const DETAILS = [
    { label: 'Sport', key: 'sportName' },
    { label: 'Tournament', key: 'tournamentName' },
    { label: 'Market', key: 'market' },
    { label: 'Selection', key: 'selection' },
    { label: 'Max Bet Percentage', key: 'maxBetPercentage' },
    { label: 'Event Stake', key: 'eventStake' },
    { label: 'Baseline Tournament Stake', key: 'avgTournamentStake' },
    { label: 'Report Date', key: 'reportDate' }
  ];

  const renderValue = (detail, alert) => {
    const value = alert?.[detail.key];
    if (detail.key === 'maxBetPercentage' && alert?.type === 'maxBet') {
      return `${value}%`;
    }
    if (detail.key === 'avgTournamentStake' && alert?.type === 'suddenSpike') {
      return currencyFormat(value, groupId);
    }
    if (detail.key === 'eventStake' && alert?.type === 'suddenSpike') {
      return currencyFormat(value, groupId);
    }
    if (detail.key === 'stake' && alert?.type === 'maxBet') {
      return currencyFormat(value, groupId);
    }
    if (detail.key === 'reportDate') {
      return DateFormat(value);
    }

    if (typeof value === 'string' && detail.trim && value.length > detail.trim) {
      return `${value.slice(0, detail.trim)}...`;
    }
    return value || '-';
  };
  const VISIBILITY_RULES = {
    maxBetPercentage: 'maxBet',
    eventStake: 'suddenSpike',
    avgTournamentStake: 'suddenSpike',
    market: 'maxBet',
    selection: 'maxBet',
    stake: 'maxBet',
  };
  const shouldShowColumn = (detailKey, alertType) => {
    // If no rule exists → always show
    if (!VISIBILITY_RULES[detailKey]) return true;

    // Show only when alert type matches
    return VISIBILITY_RULES[detailKey] === alertType;
  };
  const checkedHandler = (rowData) => {
    modalHandler(rowData);
  }
  return (
    <>
      <section className="alert-notifications-section">
        {isLoading ? (
          <div className="alerts-wrapper">
            <div className="alerts-grid">
              {[...Array(12)].map((_, index) => (
                <div key={index} className="alert-box">
                  <div className="alert-box-header">
                    <PR.Skeleton width="6rem" height="2rem" />
                    <PR.Skeleton width="4rem" height="2.5rem" />
                  </div>
                  <div className="alert-box-content">
                    <div style={{ padding: "0px 20px" }}>
                      <PR.Skeleton width="80%" height="1.5rem" className="mb-3" />
                    </div>
                    <div className="alert-details-grid">
                      <div className="detail-row">
                        <PR.Skeleton width="100%" height="1rem" className="mb-2" />
                      </div>
                      <div className="detail-row">
                        <PR.Skeleton width="90%" height="1rem" className="mb-2" />
                      </div>
                      <div className="detail-row">
                        <PR.Skeleton width="95%" height="1rem" className="mb-2" />
                      </div>
                    </div>
                  </div>
                  <div className="alert-box-footer">
                    <div className="button-group">
                      <PR.Skeleton width="6rem" height="2rem" />
                      <PR.Skeleton width="6rem" height="2rem" />
                    </div>
                    <PR.Skeleton width="4rem" height="1rem" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) :
          <div className="alerts-wrapper">
            {alertDetectedData.length > 0 ? (
              <div className="alerts-grid">
                {alertDetectedData?.slice(0, pageDisplayCount).map((alert, index) => (
                  <div key={`${alert.betAlertID}-${alert.reportID}-${alert.type}-${index}`} className="alert-box">
                    <div className="alert-box-header">
                      <div className='displayTitleGrid'>
                        <i className={`${alertTypeIcons[alert.type]} iconColor`} title={alertTypes[alert.type]}></i>
                        <span className='alertType'>{alertTypes[alert.type]?.toUpperCase()}</span>
                      </div>
                      <div className="alert-stat-section">
                        {alert.type === 'maxBet' && (
                          <>
                            <div className="stat-value">
                              <div>
                                <div className="stat-label">MAX BET PERCENTAGE</div>
                                {renderValue({ key: 'maxBetPercentage' }, alert)}
                              </div>
                              <span className="value">
                                {renderValue({ key: 'stake' }, alert)} <br />
                                <span className="label">STAKE</span>
                              </span>
                            </div>
                          </>
                        )}
                        {alert.type === 'suddenSpike' && (
                          <>
                            <div className="stat-label">EVENT STAKE</div>
                            <div className="stat-value">{renderValue({ key: 'eventStake' }, alert)}</div>
                          </>
                        )}
                      </div>
                    </div>

                    <div className="alert-box-content">
                      <h2 className='eventName'>{alert.eventName?.length > 60 ? alert.eventName?.slice(0, 60) + '...' : alert.eventName}</h2>

                      <div className="alert-details-grid">
                        {DETAILS.map((detail) => {
                          if (detail.key === 'maxBetPercentage' || detail.key === 'eventStake' || detail.key === 'reportDate') return null;
                          if (!shouldShowColumn(detail.key, alert?.type)) return null;

                          return (
                            <div className="detail-row" key={detail.key}>
                              <span className="detail-label">{detail.label.toUpperCase()}</span>
                              <span className="detail-value">{renderValue(detail, alert)}</span>
                            </div>
                          );
                        })}
                      </div>
                    </div>

                    <div className="alert-box-footer">
                      <div className="button-group">
                        <PR.Button
                          label="View Details"
                          className="view-button"
                          onClick={() => {
                            if (alert.type === 'maxBet') {
                              return navigate(`/bet-details/${alert.reportID}`, { state: { type: 'anomalies', groupId } })
                            } else if (alert.type === 'suddenSpike') {
                              return navigate(`/event-bet-list`, { state: { type: 'anomalies', searchRequest: { ...searchRequest, events: [alert.eventName] }, event: alert.eventName } })
                            }
                          }}
                        />
                        <PR.Button
                          label={alert.reviewed ? "Reviewed" : "Mark as Reviewed"}
                          className={`reviewed-button ${alert.reviewed ? "checked" : ""}`}
                          onClick={() => checkedHandler(alert)}
                        />
                      </div>
                      <div className="report-date">
                        {renderValue({ key: 'reportDate' }, alert)}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="no-alerts">
                <p>No alerts found.</p>
              </div>
            )}
          </div>
        }
      </section>
    </>
  );
};

export default AlertNotifications;
